import { render, staticRenderFns } from "./KroksGrid.vue?vue&type=template&id=8a16f206"
import script from "./KroksGrid.vue?vue&type=script&lang=js"
export * from "./KroksGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports